import { SlateNode } from '@src/components/sco/RichMarkdownInput'
import { EditorElementTypes } from '@src/components/sco/RichMarkdownInput/components/Element'
import {
  splitOffCurrentLine,
  textBeforeCaret,
} from '@src/components/sco/RichMarkdownInput/plugins/lineBreaks'
import { isHotkey } from 'is-hotkey'
import { Editor, Element as SlateElement, Point, Range, Transforms } from 'slate'

export const MARKDOWN_TRIGGERS: { [hotkey: string]: string } = {
  // '*': EditorElementTypes.LIST_ITEM,
  // '-': EditorElementTypes.LIST_ITEM,
  // '+': EditorElementTypes.LIST_ITEM,
  '>': EditorElementTypes.BLOCK_QUOTE,
  '`': EditorElementTypes.CODE_BLOCK,
  '#': EditorElementTypes.HEADING_ONE,
  '##': EditorElementTypes.HEADING_TWO,
  '###': EditorElementTypes.HEADING_THREE,
  '####': EditorElementTypes.HEADING_FOUR,
  '#####': EditorElementTypes.HEADING_FIVE,
  '######': EditorElementTypes.HEADING_SIX,
}

export function withMarkdownDetection(editor, options = {}) {
  const { onKeyDown, deleteBackward, insertText } = editor

  editor.onKeyDown = (editor, event) => {
    if (isHotkey('mod+Enter', event as any)) {
    }

    if (onKeyDown) {
      onKeyDown(editor, event)
    }
  }

  editor.insertText = text => {
    const { selection } = editor

    if (text && text.endsWith(' ') && selection && Range.isCollapsed(selection)) {
      const block = Editor.above(editor, {
        match: n => SlateElement.isElement(n) && Editor.isBlock(editor, n),
      })
      // The shortcut is the current line, so it also works after a Shift+Enter line break
      const before = block ? textBeforeCaret(editor, block[1]) : ''
      const line = before.slice(before.lastIndexOf('\n') + 1)
      const type = MARKDOWN_TRIGGERS[line + text.slice(0, -1)]

      if (type && (block[0] as SlateNode).type === EditorElementTypes.PARAGRAPH) {
        splitOffCurrentLine(editor, line, before)

        const newProperties: Partial<SlateNode> = {
          type,
        }
        Transforms.setNodes<SlateElement>(editor, newProperties, {
          match: n => SlateElement.isElement(n) && Editor.isBlock(editor, n),
        })

        if (type === EditorElementTypes.LIST_ITEM) {
          const list = {
            type: EditorElementTypes.UL_LIST,
            children: [],
          }
          Transforms.wrapNodes(editor, list, {
            match: (n: SlateNode) =>
              !Editor.isEditor(n) && SlateElement.isElement(n) && n.type === EditorElementTypes.LIST_ITEM,
          })
        }

        return
      }
    }

    if (insertText) {
      insertText(text)
    }
  }

  editor.deleteBackward = (...args) => {
    const { selection } = editor

    if (selection && Range.isCollapsed(selection)) {
      const match = Editor.above(editor, {
        match: (n: SlateNode) => SlateElement.isElement(n) && Editor.isBlock(editor, n),
      })

      if (match) {
        const block = match[0] as SlateNode
        const path = match[1]
        const start = Editor.start(editor, path)

        if (
          !Editor.isEditor(block) &&
          SlateElement.isElement(block) &&
          block.type !== EditorElementTypes.PARAGRAPH &&
          Point.equals(selection.anchor, start)
        ) {
          const newProperties: Partial<SlateNode> = {
            type: EditorElementTypes.PARAGRAPH,
          }
          Transforms.setNodes(editor, newProperties)

          if (block.type === EditorElementTypes.LIST_ITEM_TEXT) {
            Transforms.unwrapNodes(editor, {
              match: (n: SlateNode) =>
                !Editor.isEditor(n) && SlateElement.isElement(n) && n.type === EditorElementTypes.LIST_ITEM,
              split: true,
            })
          }

          return
        }
      }

      if (deleteBackward) {
        deleteBackward(...args)
      }
    }
  }

  return editor
}
